import { render } from "./RejectOrderModal.vue?vue&type=template&id=4c607025"
import script from "./RejectOrderModal.vue?vue&type=script&lang=js"
export * from "./RejectOrderModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__